import * as z from "zod";

/**
 * Fields common to both Disputely enrollment RPCs. `billingEnabled` is false
 * when no active payment method exists, so Redo finishes billing manually.
 */
export const enrollmentResultBase = z.object({
  success: z.boolean(),
  error: z.string().optional(),
  billingEnabled: z.boolean().optional(),
});
